<label for="values-{filterObject.id}">Wert</label>
<input type="number" id="values-{filterObject.id}" min="0" max="100" value={filterObject.getValue()}  class="h-10 inline border border-gray-200 w-full p-2 px-3 rounded focus:outline-none invalid:bg-red-50 invalid:border-red-500" required placeholder="Wert eingeben"
       on:input={(e) => {onUpdateFilter(filterObject, e.target) }}>

<script>
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();

    export let filterObject;

    function onUpdateFilter(filterObject, target) {
        let value =  "";
        if (target.value >= parseInt(target.getAttribute("min")) && target.value <= parseInt(target.getAttribute("max"))) {
            value = target.value;
        }

        dispatch("updateFilter", {
            filterObject,
            type: "values",
            value
        });
    }
</script>